export default __webpack_public_path__ + "static/Group 299-a2f1c5bf2105c8d297931e4885cc2f21.webp";